const equality = `Suomessa uskotaan, että kaikkia kohdellaan tasa-arvoisesti ja oikeudenmukaisesti.
He ymmärtävät, että jokainen on erilainen ja se on ok.
He haluavat varmistaa, että kaikilla on samat mahdollisuudet ja oikeudet.
On tärkeää, että jokainen, olipa hän kuka tahansa, tuntee olonsa turvalliseksi ja arvostetuksi.
Suomalaiset tekevät työtä sen eteen, että ketään ei kohdella eri tavalla esimerkiksi ihonvärin, kulttuurin tai kotoisuuden vuoksi.
He uskovat, että kaikilla pitäisi olla samat mahdollisuudet elämässä.
Suomessa naisilla ja miehillä on samat oikeudet ja he voivat tehdä samoja töitä.
On tärkeää, että kaikki saavat saman palkan samasta työstä.
Ihmiset pyrkivät myös varmistamaan, että vammaisilla on samat mahdollisuudet päästä kouluihin ja rakennuksiin.
He haluavat varmistaa, että jokainen voi elää elämäänsä vapaasti ja ihmisarvoisesti.
Kaiken kaikkiaan on hienoa nähdä, että suomalaiset välittävät tasa-arvosta ja oikeudenmukaisuudesta.
He työskentelevät varmistaakseen, että jokainen tuntee kuuluvansa ja että heitä arvostetaan.
On tärkeää jatkaa työtä kohti maailmaa, jossa kaikkia kohdellaan kunnioittavasti ja ystävällisesti`;

export default equality;